export default [
  {
    path: '/adicoes',
    name: 'Adicoes',
    component: () => import(/* webpackChunkName: "Adicoes" */ '../adicoes/Adicoes')
  },
  {
    path: '/adicoes-cadastro',
    name: 'AdicoesCadastro',
    component: () => import(/* webpackChunkName: "AdicoesCadastro" */ '../adicoes/AdicoesCadastro')
  },
  {
    path: '/adicoes-lista',
    name: 'AdicoesLista',
    component: () => import(/* webpackChunkName: "AdicoesLista" */ '../adicoes/AdicoesLista')
  }
]



// WEBPACK FOOTER //
// ./src/pages/configuracoes/adicoes/router.js